import 'live/services/authorization'
import i18n from 'live/services/i18n'
import { LiveApi } from 'live/lib/api'
import Router from 'live/services/router'
import SettingsService from 'live/services/settings'
import ServiceLocator from 'live/services/service-locator'
import globalNotification from 'live/services/global-notification'

import permission from './services/permission'
import TemplatesRouter from './router/Router'
import TemplateSettings from './template/settings/'
import TemplateFormRenderer from './template/renderers/TemplateFormRenderer'
import TemplateAnnotationRenderer from './template/renderers/TemplateAnnotationRenderer'

import './i18n'
import { performanceTestAnnotationsWithTemplates } from './performance-test'

const registerTemplateInConfig = (): void => {
    LiveApi.Extension.configuration.entries.register({
        name: i18n('Templates'),
        area: 'annotations-templates',
        component: TemplatesRouter,
        group: 'annotations',
        addRoute: true,
        routeUrl: 'annotations-templates',
        url: '/#/config/annotations-templates'
    })

    Router.route('/#/config/annotations-templates', TemplatesRouter, 'templates-router', null)
}

try {
    if (permission.canUseAnnotationsTemplates()) {
        registerTemplateInConfig()
        SettingsService.register(TemplateSettings)
        ServiceLocator.getService('timeline-form-registry').then(service => service.register(TemplateFormRenderer))
        ServiceLocator.getService('timeline-event-renderer-registry').then(service =>
            service.register(TemplateAnnotationRenderer)
        )
        // performanceTestAnnotationsWithTemplates()
    }
} catch (error) {
    globalNotification.error('Error starting plugin-annotations-templates' + error)
}
